/**
 * Subscribes to `@hsus-dev/cross-portal-logout` on the Form Engine channel.
 * When another tab or a peer portal signals logout (cookie, storage, or BroadcastChannel), flushes pending `/examform`
 * auto-save (when mounted), then tears down FEP auth and navigates to `/signed-out` (not `/error`).
 */
import { useEffect } from 'react';
import {
  AUTH_BROADCAST_CHANNEL_NAMES,
  subscribeToCrossPortalLogoutSignals,
} from '@hsus-dev/cross-portal-logout';
import { useAuth } from '../../context/authReactContext';
import { performCrossPortalSilentLogout } from '../../services/portalLogout.service';
import { isAuthRegistrationPath } from '../../utils/authRegistrationPath.utils';

export function CrossPortalLogoutListener(): null {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    return subscribeToCrossPortalLogoutSignals(AUTH_BROADCAST_CHANNEL_NAMES.FORM_ENGINE, () => {
      if (isAuthRegistrationPath(window.location.pathname)) {
        return;
      }
      void performCrossPortalSilentLogout();
    });
  }, [isAuthenticated]);

  return null;
}
